import { useContext, useState, createContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { getUserFromToken } from "../utils/authUtils";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const decodedUser = getUserFromToken(token);

  const [user, setUser] = useState(decodedUser);
  const [isAuthenticated, setIsAuthenticated] = useState(!!decodedUser);

  const login = (token) => {
    localStorage.setItem("token", token);
    const u = getUserFromToken(token);
    setIsAuthenticated(!!u);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setUser(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        isAdmin: user?.role === "admin",
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);
